import { Icon, colors, Tooltip, Checkbox, Label } from '@cimpress/react-components';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { cx } from 'emotion';
import AsyncImage from '../../common/AsyncImage';
import { DiffStatus } from './ItemChanges';
import ReadMorePopover from '../../common/ReadMorePopover';

export const SkuInfoShape = PropTypes.shape({
  description: PropTypes.string,
  fulfiller: PropTypes.shape({
    fulfillerId: PropTypes.string,
    name: PropTypes.string
  }),
  name: PropTypes.string,
  sceneUrl: PropTypes.string,
  sku: PropTypes.string.isRequired,
  status: PropTypes.string
});

// TODO: instead of copy-pasting this code, there should be a prop in SkuCard component to override the descriptions or something.
class DiffStatusSkuCard extends PureComponent {
  static propTypes = {
    skuInfo: SkuInfoShape.isRequired,
    className: PropTypes.string,

    draggable: PropTypes.bool,

    checkable: PropTypes.bool,
    isChecked: PropTypes.bool,
    onChangeChecked: PropTypes.func,

    clickable: PropTypes.bool,
    isClicked: PropTypes.bool,

    hasAction: PropTypes.bool,
    actionIcon: PropTypes.string,
    onAction: PropTypes.func,

    disabled: PropTypes.bool,
    disabledTooltipMsg: PropTypes.string
  };

  static defaultProps = {
    draggable: false,
    checkable: false,
    hasAction: false
  };

  onAction = () => {
    const { onAction, skuInfo, disabled } = this.props;
    return onAction && !disabled && onAction(skuInfo);
  };

  onChangeChecked = () => {
    const { onChangeChecked, skuInfo } = this.props;
    return onChangeChecked && onChangeChecked(skuInfo);
  };

  getDiffStatusDescription = skuInfo => {
    if (!skuInfo) {
      return null;
    }

    let pill = null;

    switch (skuInfo.diffStatus) {
      case DiffStatus.ADDED:
        pill = <Label text="New" type="success" />;
        break;
      case DiffStatus.REMOVED:
        pill = <Label text="Removed" type="danger" />;
        break;
      case DiffStatus.CHANGED:
        pill = (
          <ReadMorePopover variety="popover" contents="The price model that is pricing this sku has been updated.">
            <Label
              text={
                <div>
                  Price Changed <i className={`fa fa-question-circle`} />
                </div>
              }
              type="warning"
            />
          </ReadMorePopover>
        );
        break;
      case DiffStatus.UNCHANGED:
        pill = <Label text="Unchanged" type="default" />;
        break;
      default:
        pill = null;
    }

    return (
      <span>
        {pill} {skuInfo.description || ''}
      </span>
    );
  };

  render() {
    const {
      disabled: propDisabled,
      skuInfo,
      className,
      draggable,
      checkable,
      isChecked,
      clickable,
      isClicked,
      hasAction,
      actionIcon,
      onAction,
      disabledTooltipMsg
    } = this.props;

    const disabled = propDisabled || skuInfo.diffStatus === DiffStatus.REMOVED;

    const innerContent = (
      <React.Fragment>
        {draggable && (
          <div className="sku-card__drag">
            <Icon name="drag_drop_l" />
          </div>
        )}
        {checkable && (
          <div className="sku-card__pre-action">
            <Checkbox
              className="sku-card__pre-action__checkbox"
              checked={isChecked}
              onChange={!disabled ? this.onChangeChecked : null}
            />
          </div>
        )}
        <div className="sku-card__info">
          <div className="sku-card__info__top">
            <span className="sku-card__info__top__sku h5">{skuInfo.sku}</span>
            {skuInfo.name && <span className="sku-card__info__top__name h5">{skuInfo.name}</span>}
          </div>
          <div className="sku-card__info__bottom">{this.getDiffStatusDescription(skuInfo)}</div>
        </div>
        <div className="sku-card__img">
          <AsyncImage src={skuInfo.sceneUrl} width={50} height={50} />
        </div>
        {hasAction && (
          <div className="sku-card__post-action">
            <button
              className={`sku-card__post-action__link sku-card__post-action__link${
                onAction && !disabled ? '--clickable' : '--disabled'
              }`}
              onClick={clickable ? null : this.onAction}>
              {!disabled ? <Icon name={actionIcon} /> : <Icon name={actionIcon} color={colors.slate} />}
            </button>
          </div>
        )}
      </React.Fragment>
    );

    return disabled ? (
      <Tooltip containerClassName={cx('sku-card', className, { disabled })} contents={disabledTooltipMsg}>
        {innerContent}
      </Tooltip>
    ) : (
      <div
        className={cx('sku-card', className, {
          'sku-card--active': isClicked,
          'sku-card--clickable': clickable
        })}
        onClick={clickable ? this.onAction : null}>
        {innerContent}
      </div>
    );
  }
}

export default DiffStatusSkuCard;
